import QueryKey from '@/enums/QueryKey';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useCompanyCommentsData(companyId: number) {
    const { data: comments, isPending: isLoadingComments } = useQuery({
        queryKey: [QueryKey.COMPANY_COMMENTS, companyId],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.dashboard.comments', companyId));
            return data.comments;
        },
    });

    return {
        comments,
        isLoadingComments,
    };
}
